import {Part} from "../part";
import {wallsThumbnail} from "../../../bvComponent/core/assets";
import {PartMenuType} from "../../../visComponents/constants";

// import ToiletPaper from "../subparts/globals/toiletPaper";
// import Towel from "../subparts/globals/towel";
import LightFixture from "../subparts/globals/lightFixture";
import DecorWindow from "../subparts/globals/decorWindow";
import DecorSeat from "../subparts/globals/decorSeat";
// import ToiletPaperHolder from "../subparts/globals/toiletPaperHolder";
import LampFixture from "../subparts/globals/lampFixture";
import Attachment from "../subparts/globals/attachment";

export default class Globals extends Part {
  static id = "Globals";
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = "Globals";
    this.partThumbnail = wallsThumbnail;

    // related items
    // this.toiletPaper = null;
    this.towel = null;
    this.lightFixture = null;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Attachment": {
        relatedItemName = "attachment";
        RelatedItemClass = Attachment;
        break;
      }
      case "Decore": {
        // if (dbFeature.displayName.includes("Towel")) {
        //   relatedItemName = "towel";
        //   RelatedItemClass = Towel;
        // } else if (dbFeature.displayName.includes("Toilet Paper")) {
        //   relatedItemName = "toiletPaper";
        //   RelatedItemClass = ToiletPaper;
        // }  else if (dbFeature.displayName.includes("Toilet Paper Holder")) {
        //   relatedItemName = "toiletPaperHolder";
        //   RelatedItemClass = ToiletPaperHolder;
        // } else
          if (dbFeature.displayName.includes("Light Fixture")) {
          relatedItemName = "lightFixture";
          RelatedItemClass = LightFixture;
        } else if (dbFeature.displayName.includes("Lamp fixture")) {
          relatedItemName = "lampFixture";
          RelatedItemClass = LampFixture;
        } else if (dbFeature.displayName.includes("Seat")) {
          relatedItemName = "lightFixture";
          RelatedItemClass = DecorSeat;
        } else if (dbFeature.displayName.includes("Window")) {
          relatedItemName = "decorWindow";
          RelatedItemClass = DecorWindow;
        }
        break;
      }
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {}

}
